export enum EmergencyContactTypes {
    NO_CENTER = 'NO_CENTER',
  
    HOME_EMERGENCY_CALL_CENTER = 'HOME_EMERGENCY_CALL_CENTER',
  
    RESCUE_CENTER = 'RESCUE_CENTER',
  }
  